import { useFetch } from "~vue/api";
import type { ListPerformanceReviewsResponse } from "~vue/types/performance_management";

export const usePerformanceReviews = (performanceMomentId: number) => {
    const fetchUrl = `/api/coach/performance_reviews/?performance_moment_id=${performanceMomentId}`;
    return useFetch(fetchUrl, { refetch: true }).get().json<ListPerformanceReviewsResponse>();
};
